/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type IssueLoginLinkUrlWithIdGenerationInput = {
  size: number;
};

export type IssueLoginLinkWithIdGenerationMutationVariables = Exact<{
  input: Types.IssueLoginLinkUrlWithIdGenerationInput;
}>;


export type IssueLoginLinkWithIdGenerationMutation = { issueLoginLinkWithIDGeneration:
    | { __typename: 'IssueLoginLinkURLWithIDGenerationErrorProviderNotFoundPayload' }
    | { __typename: 'IssueLoginLinkURLWithIDGenerationSuccessPayload', csv: any }
   };


export const IssueLoginLinkWithIdGenerationDocument = gql`
    mutation issueLoginLinkWithIDGeneration($input: IssueLoginLinkURLWithIDGenerationInput!) {
  issueLoginLinkWithIDGeneration(input: $input) {
    __typename
    ... on IssueLoginLinkURLWithIDGenerationSuccessPayload {
      csv
    }
  }
}
    `;

/**
 * __useIssueLoginLinkWithIdGenerationMutation__
 *
 * To run a mutation, you first call `useIssueLoginLinkWithIdGenerationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useIssueLoginLinkWithIdGenerationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useIssueLoginLinkWithIdGenerationMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useIssueLoginLinkWithIdGenerationMutation(options: VueApolloComposable.UseMutationOptions<IssueLoginLinkWithIdGenerationMutation, IssueLoginLinkWithIdGenerationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<IssueLoginLinkWithIdGenerationMutation, IssueLoginLinkWithIdGenerationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<IssueLoginLinkWithIdGenerationMutation, IssueLoginLinkWithIdGenerationMutationVariables>(IssueLoginLinkWithIdGenerationDocument, options);
}
export type IssueLoginLinkWithIdGenerationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<IssueLoginLinkWithIdGenerationMutation, IssueLoginLinkWithIdGenerationMutationVariables>;